import { useEffect, useState } from "react";
import api from "../api";
import { Trophy, SpinnerGap, Star } from "@phosphor-icons/react";

export default function DreamsLeaderboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/leaderboard");
        if (!cancelled) setData(data.data || []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="space-y-8 pb-12">
      <header>
        <p className="text-xs uppercase tracking-widest text-[#6F4F1D]/80">Comunidade</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Top <span className="text-[#6F4F1D]">Sonhadores</span></h1>
        <p className="text-[#4B5563] mt-3 max-w-xl text-sm">+1 ponto por tarefa concluída · +10 por sonho · –1 por dia de atraso.</p>
      </header>

      {loading ? (
        <p className="text-[#978D78] flex items-center gap-2"><SpinnerGap size={16} className="animate-spin" /> A carregar...</p>
      ) : data.length === 0 ? (
        <p className="text-[#978D78]">Ainda sem sonhadores no ranking. Sê o primeiro!</p>
      ) : (
        <ol className="rounded-2xl border border-[#E6E1D6] bg-white/[0.02] divide-y divide-white/5 overflow-hidden">
          {data.map((row, i) => (
            <li key={row.ID_Cliente}
                data-testid={`lb-row-${i}`}
                className={`flex items-center gap-4 px-5 py-4 ${row.is_me ? "bg-[#6F4F1D]/10" : ""}`}>
              <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold ${
                i === 0 ? "bg-[#6F4F1D] text-[#0F1829]" :
                i === 1 ? "bg-slate-300 text-[#0F1829]" :
                i === 2 ? "bg-[#5C4017] text-white" :
                          "bg-white text-[#4B5563]"
              }`}>{i + 1}</div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold truncate">{row.nome} {row.is_me && <span className="text-[10px] text-[#6F4F1D]">(tu)</span>}</p>
              </div>
              <div className="flex items-center gap-1.5 text-[#6F4F1D] font-bold">
                <Star size={16} weight="fill" /> {row.pontos}
              </div>
              {i === 0 && <Trophy size={20} weight="fill" className="text-[#6F4F1D]" />}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
